import collective from "./Collective";
import comparison from "./Comparison";
import manual from "./Manual";

export default {
  comparison,
  manual,
  collective,
};
